import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UniqueEntityID } from '@digibricks/domains';
import { MatchingAnswerValue } from '../../answer-value';
import { Answer } from '../answer';
import { SubmissionScore } from '../../submission-score';
export var MatchingAnswer = /*#__PURE__*/function (_Answer) {
  _inherits(MatchingAnswer, _Answer);

  var _super = _createSuper(MatchingAnswer);

  function MatchingAnswer() {
    _classCallCheck(this, MatchingAnswer);

    return _super.apply(this, arguments);
  }

  _createClass(MatchingAnswer, [{
    key: "subQuestionId",
    get: function get() {
      return this.props.subQuestionId;
    }
  }, {
    key: "value",
    get: function get() {
      return this.props.value;
    }
  }, {
    key: "hasAnswerValue",
    value: function hasAnswerValue() {
      var _this$props$value;

      return !!this.props.value && ((_this$props$value = this.props.value) === null || _this$props$value === void 0 ? void 0 : _this$props$value.answerId) !== '';
    }
  }, {
    key: "updateValue",
    value: function updateValue(newValue) {
      this.props.value = newValue;
    }
  }, {
    key: "isSkipped",
    value: function isSkipped() {
      return !this.value || this.value && this.value.answerId === '';
    }
  }], [{
    key: "create",
    value: function create(props) {
      var dataOrError = this.createBaseProps(props);

      if (dataOrError.isFailure) {
        return Result.fail(dataOrError.error);
      }

      var baseProps = dataOrError.getValue();
      var collection = [{
        argument: props.value,
        argumentName: 'Value'
      }];
      var guardCollectionResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardCollectionResult.succeeded) {
        return Result.fail(guardCollectionResult.message);
      }

      props = _objectSpread(_objectSpread({}, baseProps), props);
      return Result.ok(new MatchingAnswer(props, new UniqueEntityID(props.id)));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var basePropsOrError = this.createBaseProps(data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var subQuestionId = data.subQuestionId,
            value = data.value;
        var answerValueProps;

        if (value) {
          answerValueProps = MatchingAnswerValue.create({
            answerId: value.answerId
          }).getValue();
        }

        var props = _objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
          subQuestionId: subQuestionId,
          value: answerValueProps,
          score: data !== null && data !== void 0 && data.score || data.score === 0 ? SubmissionScore.create(data.score).getValue() : null
        });

        return Result.ok(new MatchingAnswer(props, new UniqueEntityID(props.id)));
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return MatchingAnswer;
}(Answer);